import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { BaseModel } from '@models/base.model';
import { IColumnDef } from './custom-data-table.config';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { BeyondEMRConstants } from '@helpers/beyondemrconstants';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { RoutingHelper } from '@helpers/routinghelper';
import { CustomFormDialogComponent } from '@module/custom-mat-form-dialog/custom-form-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { BeyondEMRHelper } from '@helpers/beyondemr-helper';
import { CustomDeleteDialogComponent } from '@module/custom-mat-delete-popup/custom-mat-delete.component';
import { ConfirmationDialogComponent } from '@pages/masters/servicelocation/dialog/confirmationdialog/confirmationdialog.component';

@Component({
  selector: 'app-custom-data-table',
  templateUrl: './custom-data-table.component.html',
  styleUrls: ['./custom-data-table.component.css'],
})

export class CustomDataTableComponent implements OnInit {
  gridDatabase: MatTableDataSource<BaseModel>;
  public displayedColumns: string[];
  data: Array<any>;
  id: number;
  index: number;
  UserId: string;

  @Input() Columns: Array<IColumnDef>;
  @Input() ShowEdit: boolean;
  @Input() ShowDelete: boolean;
  @Input() editUrl: string;
  @Input() deleteUrl: string;
  @Input() ShowActionButton: boolean;
  @Input() dataItems: Array<any>;
  @Input() editActionUrl: string;
  @Input() ShowAppointmentAction: boolean;
  @Input() SortingData: any;
  @Input() ComponentName: string;
  @Input() CreateEditAsDialog: boolean = false;
  @Input() DeleteURL: string;
  @Output() SortedColumn: EventEmitter<any> = new EventEmitter();
  @Output() EmitAppointment: EventEmitter<any> = new EventEmitter();
  // @Output() 
  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
    public sanitizer: DomSanitizer,
    public dialog: MatDialog,
    private routingHelper?: RoutingHelper,
    private helper?: BeyondEMRHelper,
  ) {

  }
  ngOnInit() {
    this.displayedColumns = [];
    for (let col = 0; col < this.Columns.length; col++) {
      this.displayedColumns.push(this.Columns[col].field);
    }
    if (this.ShowActionButton) {
      this.displayedColumns.push("Actions");
    }
    this.bindTable(this.dataItems);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.bindTable(this.dataItems);
  }

  bindTable(result) {
    let that = this;
    this.gridDatabase = new MatTableDataSource(result);
    this.data = this.gridDatabase.data;
    this.gridDatabase._renderChangesSubscription.add();
  }

  formatCell(value, fieldDataType?, iconClass?, field?,) {
    if (fieldDataType === 'any') {
      return value ? 'Standardized' : 'Non Standardized';
    }
    if (typeof value === 'boolean') {
      return value ? 'Yes' : 'No';
    }
    else if (fieldDataType === 'datetime') {
      const dateFormat = 'MM/dd/yyyy hh:mm a';
      const formattedValue = value ? this.datePipe.transform(value, dateFormat) : null;
      return formattedValue;
    }
    else if (fieldDataType === 'date') {
      const dateFormat = BeyondEMRConstants.DateDBFormat;
      const formattedValue = value ? this.datePipe.transform(value, dateFormat) : null;
      if (formattedValue)
        return formattedValue;
    }
    else if (fieldDataType === 'phone') {
      return this.formatPhoneNumber(value);
    }
    else if (fieldDataType === 'color') {
      return this.sanitizer.bypassSecurityTrustHtml('<div style="background-color:' + value + ';padding: 10px;margin-right:55px;margin-left:5px"> </div>');
    }
    else if (fieldDataType === 'Duration') {
      return value + ' (Min)';
    }
    else if (fieldDataType === 'boolean') {
      return value ? 'Yes' : 'No';
    }
    else if (fieldDataType === 'Assignee') {
      if (value !== "") {
        return value;
      }
      else {
        return value + ' Unassign ';
      }
    }
    else if (fieldDataType === 'AmountPaid') {
      return '$' + ' ' + value;
    }
    else if (fieldDataType === 'number') {
      return '<div class="number"></div>' + value;
    }
    else if (fieldDataType === 'icon' && value > 0) {
      return '<i class="' + iconClass + '"></i>';
    }
    return value
  }

  formatPhoneNumber(str) {
    let cleaned = ('' + str).replace(/\D/g, '');
    let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      let intlCode = (match[1] ? '+1 ' : '+1 ')
      return [intlCode, match[2], '-', match[3], '-', match[4]].join('')
    }

    return null;
  }

  getColumnValue(row: any, field: string, fieldDataType?, iconClass?): any {
    const fieldParts = field.split('.');
    let value = row;
    for (const part of fieldParts) {
      if (value && value.hasOwnProperty(part)) {
        value = value[part];
      } else {
        value = null;
        break;
      }
    }
    if (fieldDataType === 'icon') {
      return this.formatCell(value, fieldDataType, iconClass);
    } else if (fieldDataType) {
      return this.formatCell(value, fieldDataType);
    } else {
      return value;
    }
  }

  sortIconHandler(type) {
    let matchedArr = this.SortingData[type];
    if (matchedArr.includes('Asc')) {
      return 'fa fa-caret-up'
    } else if (matchedArr.includes('Desc')) {
      return "fa fa-caret-down"
    }
    return 'fa fa-caret-up tooltiptext  up'
  }

  sortHandler(type) {
    let direction;
    if (this.SortingData[type].includes('Asc')) {
      direction = 'Desc'
    } else if (this.SortingData[type].includes('Desc')) {
      direction = ''
    } else {
      direction = 'Asc'
    }
    this.SortingData = { ...this.SortingData, [type]: [direction] }
    const sortOrder = { type: type, direction: direction };
    if (direction === '') {
      this.SortedColumn.emit('');
    } else {
      this.SortedColumn.emit(sortOrder);
    }
  }

  editForm(row) {
    this.id = row.Id;
    if (this.CreateEditAsDialog) {
      const dialogRef = this.dialog.open(CustomFormDialogComponent, {
        width: '450px',
        data: {
          patient: row,
          action: 'edit',
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result === 1) {
          this.refreshTable();
          this.helper.showNotification('Provider Type Record is ' + 'Edited' + ' Successfully...!!!');
        }
        else {
          this.refreshTable();
        }
      });
    } else if (this.ComponentName == "Appointments") {
      this.EmitAppointment.emit(this.id);
    } else if (this.ComponentName == "Patient") {
      if (this.ShowAppointmentAction && row['StatusId'] > 2) {
        let id = this.routingHelper.EncodeParam(this.id);
        this.router.navigate(['patientfacesheet/' + id]);
      }
      else {
        let encodedId = this.routingHelper.EncodeParam(this.id);
        this.router.navigate([this.editActionUrl + '/' + encodedId])
      }
    } else {
      let encodedId = this.routingHelper.EncodeParam(this.id);
      this.router.navigate([this.editActionUrl + '/' + encodedId])
    }
  }

  private refreshTable() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([this.router.url]);
  }

  createAppointment(row) {
    this.id = row.Id;
    this.EmitAppointment.emit(this.id);
  }

  deleteItem(i: number, row) {
    this.index = i;
    this.id = row.Id;
    let rowData = [];
    let that = this;
    for (const colName of this.Columns) {
      if (colName.field !== 'Image' && colName.field !== 'PatientImage') {
        if (colName.headerName != "") {
          rowData[colName.headerName] = row[colName.field];
        }
        else {
          rowData[colName.field] = row[colName.field];
        }
      }
    }
    let displayInList = row.DisplayInList == true ? 1 : 0;
    let isPrimaryLocation = row.IsPrimaryLocation == true ? 1 : 0;
    if (row.Id > 0 && displayInList == 1 && isPrimaryLocation == 1) {
      const confirmationDialog = this.dialog.open(ConfirmationDialogComponent, {
        width: '600px',
        data: {
          review: rowData,
          UserId: this.UserId,
        },
      });
    }
    else {
      const dialogRef = this.dialog.open(CustomDeleteDialogComponent, {
        width: '450px',
        data: {
          patient: rowData,
          deleteURL: this.DeleteURL + '/' + this.id,
          isRecurring: rowData['RecurringAppointmentId'] > 0 ? true : false,
          multiDeleteURL: this.DeleteURL + 'Series/' + rowData['RecurringAppointmentId'] + '/' + this.id,
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result == 1) {
          this.refreshTable();
        }
      });
    }
  }
}